/* TriRig cart drawer (mockup). Cart data from /cart.js; upsells from /products/<handle>.js. */
(function(){
  'use strict';
  if(window.__trcCart)return;window.__trcCart=1;
  var root=document.getElementById('trc-cart');if(!root)return;
  var CFG={};try{CFG=JSON.parse(document.getElementById('trc-cart-config').textContent)}catch(e){}
  var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var $=function(s,el){return (el||root).querySelector(s)};
  var body=$('[data-trc-body]'),foot=$('[data-trc-foot]'),fsEl=$('[data-trc-fs]'),live=$('[data-trc-live]');
  var express=$('[data-trc-express]'),rb=$('[data-trc-rebuy]'),panel=$('.trc-panel');
  var cart=null,busy=false,isOpen=false,PROD={};

  /* Preview only: ?trc_fs=150 shows the free-shipping bar with a demo threshold on an unpublished theme. */
  try{var q=new URLSearchParams(location.search).get('trc_fs');var role=window.Shopify&&Shopify.theme&&Shopify.theme.role;
    if(q!==null&&role&&role!=='main'){sessionStorage.setItem('trc_fs',q)}
    var sv=sessionStorage.getItem('trc_fs');if(sv&&role&&role!=='main'&&!(+CFG.fs>0))CFG.fs=+sv;}catch(e){}

  /* ---------- helpers ---------- */
  function money(c){
    try{if(window.theme&&theme.Currency&&theme.settings&&theme.settings.moneyFormat)return theme.Currency.formatMoney(c,theme.settings.moneyFormat)}catch(e){}
    return '$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
  }
  function short(c){return money(c).replace(/\.00(?=\D*$)/,'')}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function name(t){return String(t||'').split(' – ')[0].split(' - ')[0].trim()}
  function img(u,w){if(!u)return '';u=String(u);if(u.indexOf('//')===0)u='https:'+u;return u+(u.indexOf('?')>-1?'&':'?')+'width='+(w||200)}
  function req(path,data){
    return fetch(ROOT+path.replace(/^\//,''),{method:data?'POST':'GET',credentials:'same-origin',cache:'no-store',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest','X-TRC':'1'},body:data?JSON.stringify(data):undefined})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})});
  }
  function say(t){live.textContent='';setTimeout(function(){live.textContent=t},30)}

  /* ---------- product groups (handles) ---------- */
  var H={
    kappa:['kappa-bottle-cage','kappa-saddle-cage','kappa-carbon-cage-kona-edition'],
    bottle:['tr-water-bottle-750ml','tr-water-bottle'],
    hyd:['front-hydration-builder','bta-riser','bta-elevator','multi-bottle-bta-rail','universal-bta-adapter-plate','bta-pro-bundle','bta-sport-bundle','bta-basic-bundle','kappa-capsule','kappa-bullet','hydra-carbon-aero-bottle'],
    arm:['carbon-arm-cups','custom-signature-open-closed-back-arm-cups','mini-open-closed-back-arm-cups','high-side-evo-arm-cups','ultimate-evo-arm-cups','angled-spacers','wingspan'],
    alpha:['alpha-prime-carbon-aero-bar-stem-combo-system-new','dragonflies','alpha-one-br-replacement-br-monopost','gamma-one-carbon','gamma-24-carbon','gamma-115-carbon','sigma-one-aero-stem']
  };
  /* Never pair BTA kits or the Universal BTA Adaptor with Alpha builder items. */
  var NO_ALPHA=['bta-pro-bundle','bta-sport-bundle','bta-basic-bundle','universal-bta-adapter-plate','multi-bottle-bta-rail','bta-riser','bta-elevator'];
  var BEST=['kappa-bottle-cage','kappa-saddle-cage','multi-bottle-bta-rail','kappa-capsule'];
  function has(list,h){return list.indexOf(h)>-1}
  function ctx(c){
    var x={handles:{},kappa:false,bottle:false,hyd:false,arm:false,alpha:false};
    (c.items||[]).forEach(function(i){var p=i.properties||{},h=i.handle;x.handles[h]=1;
      if(p._ab_build||has(H.alpha,h))x.alpha=true;
      if(p._acb_build||(has(H.arm,h)&&!p._ab_build))x.arm=true;
      if(p._hb_build||has(H.hyd,h))x.hyd=true;
      if(has(H.kappa,h)&&!p._hb_build&&!p._ab_build)x.kappa=true;
      if(has(H.bottle,h)&&!p._hb_build)x.bottle=true;});
    return x;
  }
  function picks(c){
    var x=ctx(c),out=[];
    if(x.kappa)out.push('tr-water-bottle-750ml','kappa-saddle-cage','kappa-bottle-cage');
    if(x.bottle)out.push('kappa-bottle-cage','kappa-saddle-cage');
    if(x.hyd)out.push('tr-water-bottle-750ml','kappa-saddle-cage','kappa-bullet','kappa-capsule');
    if(x.arm)out.push('angled-spacers','wingspan','universal-bta-adapter-plate');
    if(x.alpha)out.push('kappa-saddle-cage','tr-water-bottle-750ml','silca-4mm-br-hex-wrench-br-single-wrench');
    out=out.concat(BEST);
    var seen={};
    var nob=rbOffer();
    return out.filter(function(h){if(seen[h]||x.handles[h])return false;if(nob&&has(H.bottle,h))return false;if(x.alpha&&has(NO_ALPHA,h))return false;seen[h]=1;return true}).slice(0,4);
  }
  /* "Most riders run two": exactly one standalone Kappa cage or TR bottle line at quantity 1. */
  function second(c){
    var L=(c.items||[]).filter(function(i){var p=i.properties||{};return !p._hb_build&&!p._ab_build&&!p._acb_build});
    var k=L.filter(function(i){return has(H.kappa,i.handle)});
    if(k.length===1&&k[0].quantity===1)return k[0];
    var b=L.filter(function(i){return has(H.bottle,i.handle)});
    if(!k.length&&b.length===1&&b[0].quantity===1&&!rbOffer())return b[0];
    return null;
  }
  function product(h){
    if(PROD[h])return PROD[h];
    var ck='trc_p_'+h;try{var s=sessionStorage.getItem(ck);if(s){var o=JSON.parse(s);if(Date.now()-o.t<6e5)return PROD[h]=Promise.resolve(o.p)}}catch(e){}
    return PROD[h]=fetch(ROOT+'products/'+h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){if(!r.ok)throw 0;return r.json()})
      .then(function(p){try{sessionStorage.setItem(ck,JSON.stringify({t:Date.now(),p:p}))}catch(e){}return p}).catch(function(){return null});
  }

  /* ---------- Rebuy offer (existing widget, e.g. 295808 "Discount Products": TR bottle offer) ----------
     The real Rebuy widget is rendered by Rebuy's own script, so its pricing, discount and analytics stay Rebuy's. */
  function rbOffer(){return !!(rb&&rb.querySelector('.rebuy-widget.is-visible .rebuy-product-block'))}
  function rbSync(){
    if(!rb)return;var on=rbOffer()&&!!(cart&&cart.item_count);
    rb.hidden=!on;
    /* Label only: Rebuy's variant button reads "Choose color" in this drawer (Rebuy keeps its own click behaviour). */
    rb.querySelectorAll('.rebuy-button').forEach(function(b){var t=(b.textContent||'').trim();if(/^color\s*\/\s*size$/i.test(t)){b.setAttribute('data-trc-lbl','Choose color')}else b.removeAttribute('data-trc-lbl')});
    if(on){root.querySelectorAll('.trc-ups .trc-card').forEach(function(c){if(has(H.bottle,c.getAttribute('data-h')))c.remove()});
      var u=$('.trc-ups');if(u&&!u.children.length&&u.getAttribute('data-done')){var l=u.previousElementSibling;if(l&&l.classList.contains('trc-lab'))l.remove();u.remove()}
      else if(u&&u.children.length===1)u.classList.add('one');}
  }
  var rbInit=false,rbT=null;
  function rbMount(){
    if(!rb)return;var slot=$('[data-rb-slot]');
    if(slot){slot.appendChild(rb)}else{panel.appendChild(rb);rb.hidden=true}
    var w=rb.querySelector('[data-rebuy-id]');
    if(window.Rebuy&&typeof Rebuy.reinit==='function'&&w&&w.getAttribute('data-initialized')!=='true'&&!rbInit){rbInit=true;try{Rebuy.reinit()}catch(e){}}
    rbSync();
  }
  if(rb&&window.MutationObserver)new MutationObserver(function(){clearTimeout(rbT);rbT=setTimeout(rbSync,60)}).observe(rb,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class']});

  /* ---------- render ---------- */
  var KIND={_hb_build:['Front hydration build','hb'],_acb_build:['Arm cups build','acb'],_ab_build:['Alpha Prime build','ab']};
  function buildKey(i){var p=i.properties||{};for(var k in KIND){if(p[k])return k+':'+p[k]}return ''}
  function discPills(i){
    var a=(i.line_level_discount_allocations||[]).filter(function(d){return d.amount>0});
    if(!a.length)return '';
    return '<div class="trc-disc">'+a.map(function(d){var t=(d.discount_application&&d.discount_application.title)||'Discount';return '<span class="trc-pill o">'+esc(t)+' −'+esc(short(d.amount))+'</span>'}).join('')+'</div>';
  }
  function props(i){
    var p=i.properties||{},o=[];for(var k in p){if(!p[k]||k.charAt(0)==='_')continue;o.push(esc(k)+': '+esc(p[k]))}
    return o.length?'<div class="trc-v">'+o.join(' · ')+'</div>':'';
  }
  function lineHTML(i){
    var v=(i.variant_title&&i.variant_title!=='Default Title')?'<div class="trc-v">'+esc(i.variant_title)+'</div>':'';
    var was=i.original_line_price>i.final_line_price?'<s>'+esc(money(i.original_line_price))+'</s>':'';
    var im=i.featured_image&&i.featured_image.url||i.image;
    return '<div class="trc-line" data-key="'+esc(i.key)+'">'+
      '<a class="trc-img" href="'+esc(i.url)+'" tabindex="-1" aria-hidden="true">'+(im?'<img src="'+esc(img(im,180))+'" alt="" width="72" height="72" loading="lazy">':'')+'</a>'+
      '<div class="trc-info"><a class="trc-t" href="'+esc(i.url)+'">'+esc(name(i.product_title))+'</a>'+v+props(i)+discPills(i)+
      '<div class="trc-row"><div><span class="trc-qty"><button type="button" data-q="-1" aria-label="Decrease quantity">−</button><span>'+i.quantity+'</span><button type="button" data-q="1" aria-label="Increase quantity">+</button></span>'+
      '<button type="button" class="trc-rm" data-rm>Remove</button></div><div class="trc-price">'+was+esc(money(i.final_line_price))+'</div></div></div></div>';
  }
  function linesHTML(c){
    var groups={},order=[],solo=[];
    c.items.forEach(function(i){var k=buildKey(i);if(k){if(!groups[k]){groups[k]=[];order.push(k)}groups[k].push(i)}else solo.push(i)});
    var h='';
    order.forEach(function(k){var L=groups[k],kind=KIND[k.split(':')[0]][0];
      var saved=L.reduce(function(s,i){return s+(i.original_line_price-i.final_line_price)},0);
      var parts=L.reduce(function(s,i){return s+i.quantity},0);
      h+='<div class="trc-group"><div class="trc-group-h"><strong>'+esc(kind)+' · '+parts+' part'+(parts>1?'s':'')+'</strong>'+(saved>0?'<span class="trc-pill g">Saving '+esc(short(saved))+'</span>':'')+'</div>'+L.map(lineHTML).join('')+'</div>';});
    if(solo.length)h+='<div class="trc-lines">'+solo.map(lineHTML).join('')+'</div>';
    return h;
  }
  function cardHTML(p,opt){
    opt=opt||{};
    var vs=(p.variants||[]).filter(function(v){return v.available});
    if(!vs.length)return '';
    var v=opt.variant?vs.filter(function(x){return x.id===opt.variant})[0]||vs[0]:vs[0];
    var im=(v.featured_image&&v.featured_image.src)||p.featured_image;
    var sel=(!opt.variant&&vs.length>1&&vs.length<=6)?'<select class="trc-vsel" aria-label="Choose '+esc(name(p.title))+' option">'+vs.map(function(x){return '<option value="'+x.id+'" data-p="'+x.price+'">'+esc(vname(x.title,p.title))+'</option>'}).join('')+'</select>':'';
    var title=opt.title||name(p.title);
    var sub=opt.sub?'<div class="trc-v">'+esc(opt.sub)+'</div>':'';
    return '<div class="trc-card" data-h="'+esc(p.handle)+'"><a class="trc-img" href="/products/'+esc(p.handle)+'" tabindex="-1" aria-hidden="true">'+(im?'<img src="'+esc(img(im,160))+'" alt="" width="60" height="60" loading="lazy">':'')+'</a>'+
      '<div class="trc-info"><a class="trc-t" href="/products/'+esc(p.handle)+'">'+esc(title)+'</a>'+sub+sel+
      '<div class="trc-card-r"><span class="trc-card-p" data-price>'+esc(short(v.price))+'</span><button type="button" class="trc-add'+(opt.hot?' o':'')+'" data-add="'+v.id+'" aria-label="Add '+esc(title)+' to cart">'+(opt.cta||'Add')+'</button></div>'+
      '<div class="trc-err" data-err hidden></div></div></div>';
  }
  function upsells(c,box){
    var two=second(c),hs=picks(c);
    var jobs=hs.map(function(h){return product(h).then(function(p){return p?cardHTML(p):''})});
    if(two)jobs.unshift(product(two.handle).then(function(p){return p?cardHTML(p,{variant:two.variant_id,title:'Most riders run two',sub:name(two.product_title),cta:'Add a second',hot:true}):''}));
    Promise.all(jobs).then(function(a){a=a.filter(Boolean).slice(0,4);if(!a.length){box.parentNode&&box.previousSibling&&box.previousSibling.remove();box.remove();return}
      box.innerHTML=a.join('');box.setAttribute('data-done','1');if(a.length===1)box.classList.add('one');rbSync();});
  }
  function vname(v,t){var base=String(v).replace(/\s*\([^)]*\)/g,'').trim();var core=String(t).split(/\s+[\u2013\u2014-]\s+/)[0].toLowerCase().split(/\s+/);var out=base.split(/\s+/).filter(function(w){return core.indexOf(w.toLowerCase())<0}).join(' ').trim();if(!out)out=base;return out.charAt(0).toUpperCase()+out.slice(1)}
  function emptyHTML(){
    var b=(CFG.builders||[]).map(function(x){return '<a class="trc-bld" href="'+esc(x.url)+'"><span class="trc-img"><img src="'+esc(x.img)+'" alt="" width="88" height="66" loading="lazy"></span>'+
      '<span><span class="trc-bld-tag">'+esc(x.tag)+'</span><span class="trc-bld-t">'+esc(x.title)+'</span><span class="trc-bld-s">'+esc(x.sub)+'</span></span>'+
      '<span class="trc-bld-go" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span></a>'}).join('');
    return '<div class="trc-empty"><h3 class="trc-empty-h">Your cart is empty</h3><p class="trc-empty-p">Start with a builder and see your exact setup before you buy.</p>'+b+
      '<div class="trc-lab">Best sellers</div><div class="trc-best" data-best></div><a class="trc-shop" href="/collections/all">Shop all products</a></div>';
  }
  function fsHTML(c){
    var t=Math.round((+CFG.fs||0)*100);
    var ok=t>0&&String(CFG.fsCountries||'').split(/[\s,]+/).indexOf(String(CFG.country||'').toUpperCase())>-1;
    if(!ok||!c.item_count){fsEl.hidden=true;return}
    var left=t-c.total_price,pct=Math.max(4,Math.min(100,Math.round(c.total_price/t*100)));
    fsEl.hidden=false;fsEl.classList.toggle('is-done',left<=0);
    fsEl.innerHTML='<p>'+(left>0?'You’re <b>'+esc(short(left))+'</b> away from free shipping':'<b>You’ve unlocked free shipping</b>')+'</p><div class="trc-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="'+pct+'"><i style="width:'+pct+'%"></i></div>';
  }
  function render(c){
    cart=c;
    var n=c.item_count||0;
    $('[data-trc-count]').textContent=n?n+(n>1?' items':' item'):'';
    updateBubble(n);
    fsHTML(c);
    if(!n){
      body.innerHTML=emptyHTML();foot.hidden=true;rbMount();
      var best=$('[data-best]');
      Promise.all(BEST.map(function(h){return product(h).then(function(p){return p?cardHTML(p):''})})).then(function(a){best.innerHTML=a.filter(Boolean).join('')});
      return;
    }
    body.innerHTML='<div class="trc-lab">In your cart</div>'+linesHTML(c)+'<div class="trc-lab">Pairs well with your setup</div><div class="trc-ups" data-ups></div><div data-rb-slot></div><div data-express-slot></div>';
    rbMount();
    upsells(c,$('[data-ups]'));
    if(express){var slot=$('[data-express-slot]');express.hidden=false;express.classList.add('trc-express');slot.appendChild(express)}
    var saved=c.total_discount||0;
    var codes=(c.cart_level_discount_applications||[]).map(function(d){return d.title}).concat(
      [].concat.apply([],c.items.map(function(i){return (i.line_level_discount_allocations||[]).map(function(d){return d.discount_application&&d.discount_application.title})})));
    codes=codes.filter(function(t,ix){return t&&codes.indexOf(t)===ix});
    var sv=$('[data-trc-save]');
    if(saved>0){sv.hidden=false;sv.innerHTML='<span>You’re saving '+esc(short(saved))+(codes.length?'<small>'+esc(codes.join(' + '))+'</small>':'')+'</span><span class="trc-pill g">−'+esc(short(saved))+'</span>'}else sv.hidden=true;
    $('[data-trc-sub]').innerHTML=(c.original_total_price>c.total_price?'<s>'+esc(money(c.original_total_price))+'</s>':'')+esc(money(c.total_price));
    $('[data-trc-total]').textContent=short(c.total_price);
    foot.hidden=false;
  }
  function updateBubble(n){
    document.querySelectorAll('.cart-link__bubble').forEach(function(b){b.classList.toggle('cart-link__bubble--visible',n>0)});
    document.querySelectorAll('[data-cart-count]').forEach(function(b){b.textContent=n});
  }
  function load(){return req('cart.js').then(function(c){render(c);return c}).catch(function(){})}

  /* ---------- actions ---------- */
  function change(key,qty,el){
    if(busy)return;busy=true;if(el)el.classList.add('trc-busy');
    req('cart/change.js',{id:key,quantity:qty}).then(function(c){busy=false;render(c);notify();say(qty?'Cart updated':'Item removed')})
      .catch(function(e){busy=false;if(el)el.classList.remove('trc-busy');say((e&&e.description)||'Could not update the cart')});
  }
  function add(id,btn){
    if(busy)return;busy=true;btn.disabled=true;var card=btn.closest('.trc-card'),err=card&&card.querySelector('[data-err]');if(err)err.hidden=true;
    var t=btn.textContent;btn.textContent='Adding…';
    req('cart/add.js',{items:[{id:+id,quantity:1}]}).then(function(){busy=false;return load()}).then(function(){notify();say('Added to cart')})
      .catch(function(e){busy=false;btn.disabled=false;btn.textContent=t;if(err){err.hidden=false;err.textContent=(e&&(e.description||e.message))||'Couldn’t add it. Please try again.'}});
  }
  /* Let the theme and other scripts (Kona auto-add, counters) know the cart changed. */
  function notify(){try{document.dispatchEvent(new CustomEvent('cart:build',{detail:{trc:1}}))}catch(e){}}
  root.addEventListener('click',function(e){
    var t=e.target;
    if(t.closest('[data-trc-close]')){e.preventDefault();close();return}
    var a=t.closest('[data-add]');if(a){e.preventDefault();add(a.getAttribute('data-add'),a);return}
    var line=t.closest('.trc-line');if(!line||!cart)return;
    var key=line.getAttribute('data-key'),it=cart.items.filter(function(i){return i.key===key})[0];if(!it)return;
    var q=t.closest('[data-q]');if(q){change(key,Math.max(0,it.quantity+(+q.getAttribute('data-q'))),line);return}
    if(t.closest('[data-rm]'))change(key,0,line);
  });
  root.addEventListener('change',function(e){var s=e.target.closest('.trc-vsel');if(!s)return;var card=s.closest('.trc-card'),o=s.options[s.selectedIndex];
    card.querySelector('[data-add]').setAttribute('data-add',s.value);card.querySelector('[data-price]').textContent=short(+o.getAttribute('data-p'))});

  /* ---------- open / close ---------- */
  var lastFocus=null;
  function open(){
    if(document.getElementById('CartPageForm'))return false;
    lastFocus=document.activeElement;root.hidden=false;document.documentElement.classList.add('trc-lock');
    requestAnimationFrame(function(){root.classList.add('is-open')});isOpen=true;
    setTimeout(function(){var x=$('.trc-x');x&&x.focus({preventScroll:true})},60);
    load();return true;
  }
  function close(){
    root.classList.remove('is-open');document.documentElement.classList.remove('trc-lock');isOpen=false;
    setTimeout(function(){if(!isOpen)root.hidden=true},330);
    if(lastFocus&&lastFocus.focus)try{lastFocus.focus({preventScroll:true})}catch(e){}
  }
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&isOpen)close()});
  /* Cart icon / cart links: capture on window so this runs before Rebuy and the theme. */
  var OPENERS='.js-drawer-open-cart,[data-trc-open],a[href="/cart"],a[href$="/cart"]:not([href*="//"])';
  window.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest(OPENERS);if(!a||root.contains(a))return;
    if(e.metaKey||e.ctrlKey||e.shiftKey)return;
    if(open()){e.preventDefault();e.stopImmediatePropagation()}
  },true);
  /* Theme / builders add to cart: open this drawer instead of the Impulse drawer. */
  window.addEventListener('ajaxProduct:added',function(e){e.stopImmediatePropagation();open()},true);
  document.addEventListener('cart:build',function(e){if(e.detail&&e.detail.trc)return;if(isOpen||cart)load()});
  document.addEventListener('cart:refresh',function(){if(isOpen)load()});
  /* Other scripts (Rebuy offer Add, Kona auto-add, Redo) change the cart: refresh while open. */
  var CART_RE=/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/,wT=null;
  function ext(){if(!isOpen&&!cart)return;clearTimeout(wT);wT=setTimeout(load,350)}
  try{var _f=window.fetch;window.fetch=function(i,o){var u=typeof i==='string'?i:(i&&i.url)||'';var mine=o&&o.headers&&(o.headers['X-TRC']||(o.headers.get&&o.headers.get('X-TRC')));
    var pr=_f.apply(this,arguments);if(!mine&&CART_RE.test(u.split('#')[0]))pr.then(function(){ext()},function(){});return pr};}catch(e){}
  try{var _o=XMLHttpRequest.prototype.open,_s=XMLHttpRequest.prototype.send;XMLHttpRequest.prototype.open=function(m,u){this.__trcU=String(u||'');return _o.apply(this,arguments)};
    XMLHttpRequest.prototype.send=function(){if(CART_RE.test((this.__trcU||'').split('#')[0]))this.addEventListener('loadend',ext);return _s.apply(this,arguments)};}catch(e){}
  ['rebuy:cart.change','rebuy:cart.add'].forEach(function(n){document.addEventListener(n,ext)});
  window.TriRigCart={open:open,close:close,refresh:load};
  /* Rebuy Smart Cart: keep Rebuy loaded (widgets elsewhere) but route its flyout to this drawer. */
  var tries=0;(function patch(){
    var R=window.Rebuy&&Rebuy.SmartCart;
    if(R&&typeof R.show==='function'&&!R.__trc){R.__trc=1;R.show=function(){open()};R.hide=function(){};return}
    if(++tries<120)setTimeout(patch,500);
  })();
  load();
})();
